import { UserRole } from '@briq/shared/src/utils/types'

export type UserState = {
  token: string
  invalidContractDetected: boolean
  invalidContractConfirmed: boolean
  sessionTimeoutDetected: boolean
  sessionTimeoutConfirmed: boolean
}

export enum RegistrationChannel {
  BRQ = 'BRQ',
  AXE = 'AXE'
}

export enum PaymentOptions {
  PPR = 'PPR',
  NPP = 'NPP'
}

export enum AdminxVisibilityOption {
  ReportVisibilityUser = 'ReportVisibilityUser',
  ReportVisibilityOffice = 'ReportVisibilityOffice',
  ReportVisibilitySubscriber = 'ReportVisibilitySubscriber'
}

export enum ContractType {
  PayperClick = 'Payperclick',
  Prepaid = 'Prepaid'
}

export type TokenPayload = {
  'admx.email': string
  'admx.firstname': string
  'admx.lastname': string
  'admx.userid': string
  'admx.adminxuserid': string
  'admx.username': string
  'admx.registration-channel': RegistrationChannel
  'admx.payment-option': PaymentOptions
  'admx.visibility': AdminxVisibilityOption
  'admx.contract-type': ContractType
  'admx.show-price-off': string
  'admx.user-hash': string
  'admx.subscriberid': string
  aud: string
  iss: string
  exp: number
  'http://schemas.microsoft.com/ws/2008/06/identity/claims/role': UserRole[]
  'admx.login-as-roles': UserRole[]
  'admx.is-probe': string
  'admx.login-as-username': string
  'admx.language': string
  'admx.subscriber-external-code': string
}
